const PRICELINE_MAP_ID = '9b78a88e3a09bc92';
const GOOGLE_MAP_API_KEY = 'AIzaSyA3oQ_k-qetNGi1rYpeR2zlIoWQqczXnls';
export { GOOGLE_MAP_API_KEY, PRICELINE_MAP_ID };
